export default "__VITE_ASSET__CDznxxLO__"